import Book from "./Book";
import Magazine from "./Magazine";
import Booklet from "./Booklet";
import Minibook from "./Minibook";
import { useLanguage } from "../../Context";

export default function Publication() {
  const { language } = useLanguage();

  return (
    <div className="max-container-width py-3 position-relative primary-text-blue">
      <ul
        className="nav nav-tabs column-gap-1 border-0 p-0 publication-tab"
        style={{ overflowX: "auto", overflowY: "hidden", flexWrap: "nowrap" }}
        id="myTab"
        role="tablist"
      >
        <li className="nav-item" role="presentation">
          <button
            className="nav-link border-0 bg-body-secondary px-4 active"
            id="book-tab"
            data-bs-toggle="tab"
            data-bs-target="#book-tab-pane"
            type="button"
            role="tab"
            aria-controls="book-tab-pane"
            aria-selected="true"
          >
            {parseInt(language) === 1 ? "کتاب‌‏ها" : "کتابونه"}
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link border-0 bg-body-secondary px-4"
            id="magazine-tab"
            data-bs-toggle="tab"
            data-bs-target="#magazine-tab-pane"
            type="button"
            role="tab"
            aria-controls="magazine-tab-pane"
            aria-selected="false"
          >
            {parseInt(language) === 1 ? "مجلات" : "مجلې"}
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link border-0 bg-body-secondary px-4"
            id="booklet-tab"
            data-bs-toggle="tab"
            data-bs-target="#booklet-tab-pane"
            type="button"
            role="tab"
            aria-controls="booklet-tab-pane"
            aria-selected="false"
          >
            {parseInt(language) === 1 ? "بوکلت" : "بوکلیټ"}
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link border-0 bg-body-secondary px-4"
            id="minibook-tab"
            data-bs-toggle="tab"
            data-bs-target="#minibook-tab-pane"
            type="button"
            role="tab"
            aria-controls="minibook-tab-pane"
            aria-selected="false"
          >
            مینی‌بوک
          </button>
        </li>
      </ul>
      <div
        className="tab-content border-top border-3 bg-body-secondary p-3"
        id="publicationTab"
      >
        <div
          className="tab-pane fade show active"
          id="book-tab-pane"
          role="tabpanel"
          aria-labelledby="book-tab"
          tabIndex="0"
        >
          <Book />
        </div>

        <div
          className="tab-pane fade"
          id="magazine-tab-pane"
          role="tabpanel"
          aria-labelledby="magazine-tab"
          tabIndex="0"
        >
          <Magazine />
        </div>

        <div
          className="tab-pane fade"
          id="booklet-tab-pane"
          role="tabpanel"
          aria-labelledby="booklet-tab"
          tabIndex="0"
        >
          <Booklet />
        </div>

        <div
          className="tab-pane fade"
          id="minibook-tab-pane"
          role="tabpanel"
          aria-labelledby="minibook-tab"
          tabIndex="0"
        >
          <Minibook />
        </div>
      </div>
    </div>
  );
}
